import { IS_MOBILE } from '../constants/const'
import { onAdd, onRemove } from '../utils/class-list'
import { onSelect, onSelectAll } from '../utils/dom'

const DOM_TABS = {
  TABS_NAV: onSelect('[data-js-fil="filter"]'),
  TABS_NAV_ITEMS: onSelectAll('[data-js-fil="filter"] [data-js-fil-target]'),
  TABS_NAV_ITEMS_ACTIVE: () => {
    return onSelectAll('[data-js-fil="filter"] [data-js-fil-target].link--active')
  },
  TABS_NAV_PANELS: () => {
    return onSelectAll('.tabs-clients-tab-content.tabs--active')
  },
  TABS_NAV_PANEL: (tabActive) => {
    if (tabActive === null || tabActive === '') return

    return onSelect(`${tabActive}.tabs-clients-tab-content`)
  },
  ARROW_NAV: onSelect('[data-js-place="line"]'),
}

// find active nav element
const findActiveOffsets = () => {
  let offsets = []

  DOM_TABS.TABS_NAV_ITEMS.forEach((item) => {
    if (item.classList.contains('link--active')) {
      let parentActive = item.closest('.item--active')
      if (parentActive === null) return

      offsets = {
        decorLeft: parentActive.offsetLeft,
        decorWidth: parentActive.offsetWidth / 2,
      }
    }
  })

  return offsets
}

const setPlaceStyleArrow = (decorLeft, decorWidth) => {
  let arrowNav = DOM_TABS.ARROW_NAV
  if (arrowNav === null) return null

  let placeArrow = decorLeft + decorWidth

  arrowNav.style.left = `${placeArrow}px`
}

const setActiveTab = (activeItem) => {
  let activeTab = DOM_TABS.TABS_NAV_ITEMS_ACTIVE()
  activeTab.forEach((item) => {
    onRemove(item, 'link--active')
    onRemove(item.parentElement, 'item--active')
  })

  onAdd(activeItem, 'link--active')
  onAdd(activeItem.parentElement, 'item--active')
}

const setActivePanel = (activeTab) => {
  onRemove(DOM_TABS.TABS_NAV_PANELS(), 'tabs--active')

  let activePanel = DOM_TABS.TABS_NAV_PANEL(activeTab)
  onAdd(activePanel, 'tabs--active')
}

window.addEventListener('load', () => {
  //find active nav item
  if (DOM_TABS.TABS_NAV !== null && !IS_MOBILE) {
    const { decorLeft, decorWidth } = findActiveOffsets()
    setPlaceStyleArrow(decorLeft, decorWidth)

    DOM_TABS.TABS_NAV.addEventListener('click', (event) => {
      let clickedTab = event.target
      let attribuTab = clickedTab.getAttribute('data-js-fil-target')

      console.log(clickedTab, attribuTab)

      if (clickedTab && attribuTab !== null) {
        event.preventDefault()

        // active tab
        setActiveTab(clickedTab)

        // place arrow
        const { decorLeft, decorWidth } = findActiveOffsets()
        setPlaceStyleArrow(decorLeft, decorWidth)

        // active panel
        setActivePanel(attribuTab)
      }
    })
  } else {
    if (DOM_TABS.TABS_NAV !== null) {
      DOM_TABS.TABS_NAV.addEventListener('click', (event) => {
        let clickedTab = event.target
        let attribuTab = clickedTab.getAttribute('data-js-fil-target')

        if (clickedTab && attribuTab !== null) {
          event.preventDefault()

          // active tab
          setActiveTab(clickedTab)

          // active panel
          setActivePanel(attribuTab)
        }
      })
    }
  }
})
